// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"ed497962","361":"160f8aa5","767":"c501b048"}[chunkId] + ".chunk.js";
};